import { date, isEmpty, showAlert } from '../../../lib/helpers';
import { dataListMerchantCriteria } from '../../../store/params';
import { headers, search, dataChannelProviderMappingStatus } from './attributes';

export default {
  data: () => ({
    isFirstLoad: true,
    options: {},
    headers,
    search,
    filterValue: {
      mid: '',
      merchant_name: '',
      aggregator_name: '',
      merchant_criteria: '',
      channel_provider_id: '',
      channel_provider_mapping_status: '',
    },
    searchChannelProvider: '',
    channelProviderList: [],
    loadingChannelProvider: false,
    selectedChannelProviderId: '',
    selectedData: [],
    selectedRowsMap: {},
    selectAllData: false,
    alertConfig: {
      description: 'Hubungkan merchant QR EDC ke Channel Provider agar dapat menggunakan metode transaksi QrisTap',
      infoItems: [],
    },
    dialogProvider: false,
    dialogConfirm: false,
    dialogUnmapping: false,
    submitting: false,
    submittingUnmap: false,
    chosenProviderId: '',
  }),

  computed: {
    filterConfig() {
      return [
        { key: 'mid', type: 'textfield', props: { label: 'MID', placeholder: 'Cth: MID-123456' } },
        { key: 'merchant_name', type: 'textfield', props: { label: 'Nama Merchant', placeholder: 'Masukkan nama merchant' } },
        { key: 'aggregator_name', type: 'textfield', props: { label: 'Nama Aggregator', placeholder: 'Cth: PT Aggregator Nusantara' } },
        { key: 'merchant_criteria', type: 'select', props: { label: 'Kriteria Merchant', items: dataListMerchantCriteria, placeholder: 'Pilih kriteria...' } },
        {
          key: 'channel_provider_id',
          type: 'autocomplete',
          props: {
            label: 'Channel Provider',
            items: this.channelProviderList,
            loading: this.loadingChannelProvider,
            itemText: 'provider_name',
            itemValue: 'id',
            search: this.searchChannelProvider,
            placeholder: 'Pilih channel provider...',
          },
        },
        { key: 'channel_provider_mapping_status', type: 'select', props: { label: 'Status Mapping', items: dataChannelProviderMappingStatus, placeholder: 'Pilih status...' } },
      ];
    },
    loading() {
      return this.$store.state.mappingQrisTap.loading;
    },
    allData() {
      return this.$store.state.mappingQrisTap.allData;
    },
    totalData() {
      return this.$store.state.mappingQrisTap.totalData;
    },
    totalPage() {
      return this.$store.state.mappingQrisTap.totalPage;
    },
    filterAllow() {
      return (
        isEmpty(this.search.mid) &&
        isEmpty(this.search.merchant_name) &&
        isEmpty(this.search.aggregator_name) &&
        isEmpty(this.search.merchant_criteria) &&
        isEmpty(this.search.channel_provider_id) &&
        isEmpty(this.search.channel_provider_mapping_status)
      );
    },
    selectAllIndeterminate() {
      const pageIds = this.allData.map((row) => row.id);
      const selectedOnPage = pageIds.filter((id) => this.selectedData.includes(id));
      return selectedOnPage.length > 0 && selectedOnPage.length < pageIds.length;
    },
    selectedChannelProviderObj() {
      return this.channelProviderList.find((p) => String(p.id) === String(this.chosenProviderId));
    },
    selectedMerchantRows() {
      return this.selectedData
        .map((id) => this.selectedRowsMap[id])
        .filter((row) => !!row);
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('mappingQrisTap/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },

    searchChannelProvider(val, oldVal) {
      if (!val && !oldVal) return;
      if (this.isSelectedDisplayText(val)) return;
      this.debouncedFetchChannelProvider(val || '');
    },

    selectedData: {
      handler() {
        this.checkAllSelected();
      },
      deep: true,
    },
  },

  created() {
    this.debouncedFetchChannelProvider = this.createDebounced(this.fetchChannelProviderList, 300);
  },

  async mounted() {
    this.$store.commit('mappingQrisTap/clearData');
    this.fetchChannelProviderList();
  },

  methods: {
    isEmpty,

    baseFilterData(newSearch) {
      this.search.mid = newSearch.mid || '';
      this.search.merchant_name = newSearch.merchant_name || '';
      this.search.aggregator_name = newSearch.aggregator_name || '';
      this.search.merchant_criteria = newSearch.merchant_criteria || '';
      this.search.channel_provider_id = newSearch.channel_provider_id || '';
      this.search.channel_provider_mapping_status = newSearch.channel_provider_mapping_status || '';
      this.options.page = 1;
      this.getData();
    },

    updateSearch(newSearch) {
      this.baseFilterData(newSearch);
    },

    showType(newSearch) {
      this.baseFilterData(newSearch);
    },

    clearSearch() {
      this.search.mid = '';
      this.search.merchant_name = '';
      this.search.aggregator_name = '';
      this.search.merchant_criteria = '';
      this.search.channel_provider_id = '';
      this.search.channel_provider_mapping_status = '';
      this.searchChannelProvider = '';
      this.selectedChannelProviderId = '';
      this.clearSelected();
      this.$nextTick(() => {
        this.$router.push({ query: {} }).catch(() => {});
        this.$store.commit('mappingQrisTap/clearData');
      });
    },

    clearSelected() {
      this.selectedData = [];
      this.selectedRowsMap = {};
      this.selectAllData = false;
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = this.allData.map((val) => val.id);
        const filtered = allIds.filter((val) => !this.selectedData.includes(val));
        if (status) {
          this.selectedData = this.selectedData.concat(filtered);
          const newMap = { ...this.selectedRowsMap };
          this.allData.forEach((row) => {
            newMap[row.id] = row;
          });
          this.selectedRowsMap = newMap;
        } else {
          this.selectedData = this.selectedData.filter((val) => !allIds.includes(val));
          const newMap = { ...this.selectedRowsMap };
          allIds.forEach((id) => {
            delete newMap[id];
          });
          this.selectedRowsMap = newMap;
        }
      });
    },

    onSelectAllToggle(newValue) {
      const target = this.selectAllIndeterminate ? true : !!newValue;
      this.selectAllData = target;
      this.selectAll(target);
    },

    onRowToggle(id, checked) {
      if (checked) {
        if (!this.selectedData.includes(id)) {
          this.selectedData = [...this.selectedData, id];
        }
        const row = this.allData.find((r) => r.id === id);
        if (row) {
          this.selectedRowsMap = { ...this.selectedRowsMap, [id]: row };
        }
      } else {
        this.selectedData = this.selectedData.filter((val) => val !== id);
        const newMap = { ...this.selectedRowsMap };
        delete newMap[id];
        this.selectedRowsMap = newMap;
      }
    },

    checkAllSelected() {
      const allIds = this.allData.map((val) => val.id);
      if (allIds.length === 0) {
        this.selectAllData = false;
        return;
      }
      const remaining = allIds.filter((val) => !this.selectedData.includes(val));
      this.selectAllData = remaining.length === 0;
    },

    openMappingDialog() {
      if (this.selectedData.length < 1) {
        showAlert(this.$store, 'Pilih minimal 1 merchant terlebih dahulu!', 'mdi-alert', 'red');
        return;
      }
      this.chosenProviderId = '';
      this.dialogProvider = true;
    },

    onProviderPicked(providerId) {
      this.chosenProviderId = providerId;
      this.dialogProvider = false;
      this.dialogConfirm = true;
    },

    onProviderCancel() {
      this.dialogProvider = false;
    },

    onConfirmCancel() {
      this.dialogConfirm = false;
    },

    onConfirmBack() {
      this.dialogConfirm = false;
      this.dialogProvider = true;
    },

    async onConfirmSubmit() {
      this.submitting = true;
      try {
        const responseData = await this.$store.dispatch('mappingQrisTap/linkMapping', {
          date,
          merchantIds: this.selectedData,
          channelProviderId: this.chosenProviderId,
        });

        if (responseData?.code === 200) {
          showAlert(this.$store, 'Sukses Mapping Data', 'mdi-check-circle', 'green');
          this.dialogConfirm = false;
          this.clearSelected();
          this.getData();
        } else {
          const msg = typeof responseData?.data === 'string'
            ? responseData.data
            : responseData?.message_id || 'Mapping gagal.';
          showAlert(this.$store, msg, 'mdi-alert', 'red');
        }
      } catch (e) {
        showAlert(this.$store, e?.message || 'Mapping gagal.', 'mdi-alert', 'red');
      } finally {
        this.submitting = false;
      }
    },

    openUnmappingDialog() {
      if (this.selectedData.length < 1) {
        showAlert(this.$store, 'Pilih minimal 1 merchant terlebih dahulu!', 'mdi-alert', 'red');
        return;
      }
      this.dialogUnmapping = true;
    },

    onUnmappingCancel() {
      this.dialogUnmapping = false;
    },

    async onUnmappingSubmit() {
      this.submittingUnmap = true;
      try {
        const responseData = await this.$store.dispatch('mappingQrisTap/unlinkMapping', {
          date,
          merchantIds: this.selectedData,
        });

        if (responseData?.code === 200) {
          showAlert(this.$store, 'Sukses Unmapping Data', 'mdi-check-circle', 'green');
          this.dialogUnmapping = false;
          this.clearSelected();
          this.getData();
        } else {
          const msg = typeof responseData?.data === 'string'
            ? responseData.data
            : responseData?.message_id || 'Unmapping gagal.';
          showAlert(this.$store, msg, 'mdi-alert', 'red');
        }
      } catch (e) {
        showAlert(this.$store, e?.message || 'Unmapping gagal.', 'mdi-alert', 'red');
      } finally {
        this.submittingUnmap = false;
      }
    },

    getData() {
      if (this.filterAllow) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Mohon isi minimal 1 filter pencarian terlebih dahulu!',
          'mdi-alert',
          'red'
        );
        this.$store.commit('mappingQrisTap/clearData');
        return;
      }

      const { page, itemsPerPage } = this.options;
      this.$store
        .dispatch('mappingQrisTap/fetchMappingList', {
          date,
          page,
          itemsPerPage,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
          this.checkAllSelected();
        });
    },

    async fetchChannelProviderList(keyword = '') {
      this.loadingChannelProvider = true;
      const result = await this.$store.dispatch('channelProviderShared/getChannelProvider', {
        keyword,
        limit: 100,
      });
      if (result.success) {
        this.channelProviderList = result.data;
      }
      this.loadingChannelProvider = false;
    },

    handleFilterSearchInput(payload) {
      const { key, value } = payload || {};
      if (key === 'channel_provider_id') {
        this.searchChannelProvider = value;
      }
    },

    handleFilterValueChange(payload) {
      const { key, value } = payload || {};
      if (key === 'channel_provider_id') {
        this.selectedChannelProviderId = value || '';
      }
    },

    isSelectedDisplayText(val) {
      if (!this.selectedChannelProviderId || !val) return false;
      const selected = this.channelProviderList.find(item => item.id === this.selectedChannelProviderId);
      return !!(selected && selected.provider_name === val);
    },

    createDebounced(fn, delay) {
      let timer = null;
      return (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },
  },

  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};
